import React from 'react';
import { SkeletonLoader, Table } from '@chargify/custom-ui-components';
import { SkeletonWrapper } from './BillingHistoryLoader.styles';

const TableFooter = () => (
  <Table.Footer justifyContent="center" paddingY={4} paddingX={7}>
    <SkeletonLoader height={28} width={200} />
  </Table.Footer>
);

const BillingHistoryLoader = () => (
  <Table renderFooter={TableFooter}>
    <Table.Head variant={'primary'}>
      <Table.Row disableBorder variant={'head'}>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5}>
            <SkeletonLoader height={28} width={100} />
          </SkeletonWrapper>
        </Table.CellContainer>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5} paddingX={4}>
            <SkeletonLoader height={28} width={100} />
          </SkeletonWrapper>
        </Table.CellContainer>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5} paddingX={4} justifyContent="center">
            <SkeletonLoader height={28} width={100} />
          </SkeletonWrapper>
        </Table.CellContainer>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5} paddingX={4} justifyContent="flex-end">
            <SkeletonLoader height={28} width={100} />
          </SkeletonWrapper>
        </Table.CellContainer>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5} paddingX={4} justifyContent="flex-end">
            <SkeletonLoader height={28} width={100} />
          </SkeletonWrapper>
        </Table.CellContainer>
        <Table.CellContainer as="th">
          <SkeletonWrapper paddingY={5} paddingX={4} justifyContent="flex-end">
            <SkeletonLoader height={28} width={40} />
          </SkeletonWrapper>
        </Table.CellContainer>
      </Table.Row>
    </Table.Head>
    <Table.Body>
      <Table.Row>
        <SkeletonWrapper as="td">
          <SkeletonLoader height={28} />
        </SkeletonWrapper>
      </Table.Row>
      <Table.Row>
        <SkeletonWrapper as="td">
          <SkeletonLoader height={28} />
        </SkeletonWrapper>
      </Table.Row>
      <Table.Row>
        <SkeletonWrapper as="td">
          <SkeletonLoader height={28} />
        </SkeletonWrapper>
      </Table.Row>
      <Table.Row>
        <SkeletonWrapper as="td" justifyContent="center">
          <SkeletonLoader height={28} />
        </SkeletonWrapper>
      </Table.Row>
    </Table.Body>
  </Table>
);

export default BillingHistoryLoader;
